import useMessagesStore from '🔗/stores/messages';
import useModalsStore from '🔗/stores/modals';
import useOthersStore from '🔗/stores/others';
import useUserStore from '🔗/stores/user';
import useLocaleStore from '🔗/stores/locale';
import usePixiStore from '🔗/stores/pixi';
import useSettingsStore from '🔗/stores/settings';
import useMessengersStore from '🔗/stores/messengers';
import usePlayerStore from '🔗/stores/player';
import useTgsStore from '🔗/stores/tgs';

const stores = {
    messages: useMessagesStore,
    modals: useModalsStore,
    others: useOthersStore,
    user: useUserStore,
    locale: useLocaleStore,
    pixi: usePixiStore,
    messengers: useMessengersStore,
    settings: useSettingsStore,
    player: usePlayerStore,
    tgs: useTgsStore
}

export default stores;
